import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { initializeAnalytics } from '../index';

const CookieConsentBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="enteeonCookieConsent"
      style={{
        background: "#4a553d",
        color: "#ffffff",
        fontSize: "14px",
        padding: "20px",
        alignItems: "center",
      }}
      buttonStyle={{
        background: "#2d3e2f",
        color: "#ffffff",
        fontSize: "14px",
        borderRadius: "5px",
        padding: "10px 20px",
        margin: "0 10px",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#ffffff",
        fontSize: "14px",
        border: "1px solid #ffffff",
        borderRadius: "5px",
        padding: "10px 20px",
        margin: "0 10px",
      }}
      expires={365}
      enableDeclineButton
      onAccept={() => {
        // Consent given, initialize analytics
        initializeAnalytics();
        console.log('Cookies accepted');
      }}
      onDecline={() => {
        // Consent declined
        console.log('Cookies declined');
      }}
    >
      This website uses cookies to enhance your experience and analyze site traffic. By accepting, you consent to our use of cookies in accordance with our Privacy Policy.
    </CookieConsent>
  );
};

export default CookieConsentBanner;